<template>
  <div
    class="account-info-container"
  >
    <cube-form
      :model="model"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <cube-form-item :field="fields[0]" />
      <div class="cube-form-item-box valid-code-item">
        <cube-form-item :field="fields[1]" />
        <div class="find-pwd-box">
          <get-code
            class="find-pwd-link"
            :email="model.email"
            type="2"
            :is-disabled="false"
          />
        </div>
      </div>
      <cube-form-item :field="fields[2]" />
      <div class="cube-form-item-box valid-code-item">
        <cube-form-item :field="fields[3]" />
        <div class="find-pwd-box">
          <get-code
            class="find-pwd-link"
            :newemail="model.newemail"
            type="6"
            :is-disabled="false"
          />
        </div>
      </div>
      <div class="form-btn-box">
        <cube-button
          type="reset"
          :light="true"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          :primary="true"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-form>
  </div>
</template>
<script>
import GetCode from '@/components/mobile/GetCode'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    GetCode
  },
  data () {
    return {
      validity: {},
      valid: undefined,
      model: {
        email: this.$route.query.email,
        checkcode: '',
        newemail: '',
        newcheckcode: ''
      },
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'email',
          label: this.$t('message["1505"]'),
          props: {
            placeholder: this.$t('message["751"]'),
            disabled: true
          },
          rules: {
            required: true,
            type: 'email'
          }
        },
        {
          type: 'input',
          modelKey: 'checkcode',
          label: '',
          props: {
            placeholder: this.$t('message["824"]')
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'newemail',
          label: this.$t('message["1505"]'),
          props: {
            placeholder: this.$t('message["828"]')
          },
          rules: {
            required: true,
            type: 'email'
          }
        },
        {
          type: 'input',
          modelKey: 'newcheckcode',
          label: '',
          props: {
            placeholder: this.$t('message["824"]')
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('account/modify', [''])
  },
  async mounted () {
  },
  methods: {
    ...mapActions('account/modify', ['modifyEmail']),
    async submitHandler (e) {
      const chain = await this.modifyEmail()
      chain.params(this.model)
        .onSuccess(res => {
          this.$router.replace({ name: 'AccountInfo' })
        })
        .onNetSuccess((res) => {
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .config({ tip: false })
        .setForm(this.form)
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    resetHandler () {
      this.$router.replace({ name: 'AccountInfo' })
    }
  }
}
</script>
<style lang="scss" scoped>
  .account-info-container::v-deep {
    padding-bottom: 60px;
    .cube-form-item {
      line-height: 56px;
      min-height: 56px;
       .cube-form-label {
        color: #888;
        font-size: 16px;
      }
    }
    .cube-form-item-box .find-pwd-box {
        top: 16px;
      }
  }

</style>
